import { render, staticRenderFns } from "./BidCard.vue?vue&type=template&id=79942a72&scoped=true&"
import script from "./BidCard.vue?vue&type=script&lang=js&"
export * from "./BidCard.vue?vue&type=script&lang=js&"
import style0 from "./BidCard.vue?vue&type=style&index=0&id=79942a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79942a72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VCarousel,VCarouselItem,VContainer,VDivider,VImg})
